import { memo, useMemo } from "react";

import { BasicInfoLabelWithTextLayout } from "../../layout";

type Props = {
	guestPostalCode: string;
	guestAddress: string;
};

export const GuestAddressOfBasicInfoCompositions = memo(({ guestPostalCode, guestAddress }: Props) => {
	const guestPostalCodeText = useMemo(() => {
		return `〒 ${guestPostalCode}`;
	}, [guestPostalCode]);

	const guestAddressText = useMemo(() => {
		return `${guestAddress}`;
	}, [guestAddress]);

	return (
		<BasicInfoLabelWithTextLayout
			label="住所"
			textChildren={
				<div className="flex flex-col gap-y-1">
					<p className="break-words">{guestPostalCodeText}</p>
					<p className="break-words">{guestAddressText}</p>
				</div>
			}
		/>
	);
});
